import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-27b1313b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "login-wrapper" };
const _hoisted_2 = ["src"];
import Login from "@/components/organisms/Login.vue";
import Logo from "@/assets/Logo.svg";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginView',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                    src: _unref(Logo),
                    alt: "onedesk"
                }, null, 8, _hoisted_2),
                _createVNode(Login)
            ]));
        };
    }
});
